
import CartItem from './CartItem.vue';
import { Button, Empty } from 'element-ui';
import { ChevronDownIcon } from 'vue-feather-icons';
import CartItemCodesPromo from './CartItemCodesPromo';
import cartMixin from '@/mixins/cartMixin.js';

export default {
  mixins: [cartMixin],
  props: {
    mincart: {
      type: Boolean,
      default: false,
    },
    pageCart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // products: [],
      maxItem: 2,
      showMore: false,
      hasQuantiyErrors: [],
      hasDoubleItemErrors: [],
    };
  },

  computed: {
    allItems() {
      return this.cart?.Products;
    },

    firtsItems() {
      return this.allItems.slice(0, this.maxItem);
    },

    lastItems() {
      return this.allItems.slice(this.maxItem, this.allItems.length);
    },

    items() {
      if (this.mincart) {
        return this.firtsItems;
      }

      return this.allItems;
    },
    hasError() {
      const hasAvailabilityError = this.allItems?.some((item) => {
        const variantSelected = item.Variant?.find((v) => v.Selected);
        return (
          !variantSelected?.Available ||
          variantSelected?.Quantity < item.Quantity
        );
      });
      const error =
        hasAvailabilityError ||
        this.hasQuantiyErrors.length > 0 ||
        this.hasDoubleItemErrors.length > 0;
      this.$emit('onErrorHandler', error);
      return error;
    },
  },
  mounted() {},

  methods: {
    // addTodo(e) {
    //   this.$store.commit("todos/add", e.target.value);
    //   e.target.value = "";
    // },
    // ...mapMutations({
    //   toggle: "todos/toggle",
    // }),

    getQuantity(val) {
      if (typeof val === 'string') {
        return parseInt(val);
      }

      return val;
    },
    checkQuantityError($event) {
      const { hasError, idCartDetail } = $event;
      if (hasError) {
        const index = this.hasQuantiyErrors.findIndex(
          (item) => item.idCartDetail === idCartDetail
        );
        if (index === -1) {
          this.hasQuantiyErrors.push($event);
        } else {
          this.$set(this.hasQuantiyErrors, index, $event);
        }
      } else {
        const index = this.hasQuantiyErrors.findIndex(
          (item) => item.idCartDetail === idCartDetail
        );
        if (index !== -1) {
          this.hasQuantiyErrors.splice(index, 1);
        }
      }
    },
  },

  components: { CartItem, Empty, Button, ChevronDownIcon, CartItemCodesPromo },
};
